// src/data/postEncounterData.js
// Content data for the Post-Encounter Guide ("What Now?" walkthrough)

export const POST_ENCOUNTER_SCENARIOS = [
  // ── Branch 1: Detained & Released ─────────────────────
  {
    id: 'detained-released',
    title: 'postEncounterData.detainedReleasedTitle',
    description: 'postEncounterData.detainedReleasedDesc',
    icon: 'UserCircle',
    color: 'red',
    sections: [
      {
        id: 'document-now-dr',
        title: 'postEncounterData.documentNowDrTitle',
        icon: 'NotePencil',
        urgency: 'high',
        content: 'postEncounterData.documentNowDrContent',
        checklist: [
          'postEncounterData.documentNowDrCheck1',
          'postEncounterData.documentNowDrCheck2',
          'postEncounterData.documentNowDrCheck3',
          'postEncounterData.documentNowDrCheck4',
          'postEncounterData.documentNowDrCheck5',
          'postEncounterData.documentNowDrCheck6',
          'postEncounterData.documentNowDrCheck7',
          'postEncounterData.documentNowDrCheck8',
          'postEncounterData.documentNowDrCheck9',
        ],
        linkToFeature: 'encounter-log-after',
        linkLabel: 'postEncounterData.documentNowDrLinkLabel',
      },
      {
        id: 'legal-help-dr',
        title: 'postEncounterData.legalHelpDrTitle',
        icon: 'Scales',
        urgency: 'high',
        content: 'postEncounterData.legalHelpDrContent',
        checklist: [
          'postEncounterData.legalHelpDrCheck1',
          'postEncounterData.legalHelpDrCheck2',
          'postEncounterData.legalHelpDrCheck3',
          'postEncounterData.legalHelpDrCheck4',
          'postEncounterData.legalHelpDrCheck5',
          'postEncounterData.legalHelpDrCheck6',
          'postEncounterData.legalHelpDrCheck7',
        ],
        hotlines: [
          { name: 'National Immigration Detention Hotline', number: '1-833-560-0927' },
          { name: 'National Immigrant Justice Center', number: '312-660-1370' },
          { name: 'NILC (National Immigration Law Center)', number: '213-639-3900' },
        ],
      },
      {
        id: 'bond-court-dr',
        title: 'postEncounterData.bondCourtDrTitle',
        icon: 'Calendar',
        urgency: 'high',
        content: 'postEncounterData.bondCourtDrContent',
        checklist: [
          'postEncounterData.bondCourtDrCheck1',
          'postEncounterData.bondCourtDrCheck2',
          'postEncounterData.bondCourtDrCheck3',
          'postEncounterData.bondCourtDrCheck4',
          'postEncounterData.bondCourtDrCheck5',
          'postEncounterData.bondCourtDrCheck6',
          'postEncounterData.bondCourtDrCheck7',
        ],
      },
      {
        id: 'preserve-evidence-dr',
        title: 'postEncounterData.preserveEvidenceDrTitle',
        icon: 'ShieldCheck',
        urgency: 'medium',
        content: 'postEncounterData.preserveEvidenceDrContent',
        checklist: [
          'postEncounterData.preserveEvidenceDrCheck1',
          'postEncounterData.preserveEvidenceDrCheck2',
          'postEncounterData.preserveEvidenceDrCheck3',
          'postEncounterData.preserveEvidenceDrCheck4',
          'postEncounterData.preserveEvidenceDrCheck5',
          'postEncounterData.preserveEvidenceDrCheck6',
          'postEncounterData.preserveEvidenceDrCheck7',
        ],
      },
      {
        id: 'file-complaint-dr',
        title: 'postEncounterData.fileComplaintDrTitle',
        icon: 'FileText',
        urgency: 'medium',
        content: 'postEncounterData.fileComplaintDrContent',
        checklist: [
          'postEncounterData.fileComplaintDrCheck1',
          'postEncounterData.fileComplaintDrCheck2',
          'postEncounterData.fileComplaintDrCheck3',
          'postEncounterData.fileComplaintDrCheck4',
          'postEncounterData.fileComplaintDrCheck5',
          'postEncounterData.fileComplaintDrCheck6',
        ],
        links: [
          { name: 'DHS OIG Hotline', url: 'https://www.oig.dhs.gov/hotline' },
          { name: 'DHS CRCL Complaint Form', url: 'https://www.dhs.gov/file-crcl-complaint' },
          { name: 'ACLU Immigrants\' Rights', url: 'https://www.aclu.org/know-your-rights/immigrants-rights' },
        ],
      },
    ],
  },

  // ── Branch 2: Family Member Taken ─────────────────────
  {
    id: 'family-taken',
    title: 'postEncounterData.familyTakenTitle',
    description: 'postEncounterData.familyTakenDesc',
    icon: 'UsersThree',
    color: 'amber',
    sections: [
      {
        id: 'find-them-ft',
        title: 'postEncounterData.findThemFtTitle',
        icon: 'MapPin',
        urgency: 'high',
        content: 'postEncounterData.findThemFtContent',
        checklist: [
          'postEncounterData.findThemFtCheck1',
          'postEncounterData.findThemFtCheck2',
          'postEncounterData.findThemFtCheck3',
          'postEncounterData.findThemFtCheck4',
          'postEncounterData.findThemFtCheck5',
          'postEncounterData.findThemFtCheck6',
          'postEncounterData.findThemFtCheck7',
        ],
        hotlines: [
          { name: 'National Immigration Detention Hotline', number: '1-833-560-0927' },
          { name: 'ICE ERO (General)', number: '1-888-351-4024' },
        ],
        links: [
          { name: 'ICE Online Detainee Locator', url: 'https://locator.ice.gov' },
        ],
      },
      {
        id: 'legal-help-ft',
        title: 'postEncounterData.legalHelpFtTitle',
        icon: 'Scales',
        urgency: 'high',
        content: 'postEncounterData.legalHelpFtContent',
        checklist: [
          'postEncounterData.legalHelpFtCheck1',
          'postEncounterData.legalHelpFtCheck2',
          'postEncounterData.legalHelpFtCheck3',
          'postEncounterData.legalHelpFtCheck4',
          'postEncounterData.legalHelpFtCheck5',
          'postEncounterData.legalHelpFtCheck6',
          'postEncounterData.legalHelpFtCheck7',
        ],
        hotlines: [
          { name: 'National Immigrant Justice Center', number: '312-660-1370' },
          { name: 'NILC', number: '213-639-3900' },
        ],
      },
      {
        id: 'poa-activation-ft',
        title: 'postEncounterData.poaActivationFtTitle',
        icon: 'FileText',
        urgency: 'high',
        content: 'postEncounterData.poaActivationFtContent',
        checklist: [
          'postEncounterData.poaActivationFtCheck1',
          'postEncounterData.poaActivationFtCheck2',
          'postEncounterData.poaActivationFtCheck3',
          'postEncounterData.poaActivationFtCheck4',
          'postEncounterData.poaActivationFtCheck5',
          'postEncounterData.poaActivationFtCheck6',
          'postEncounterData.poaActivationFtCheck7',
        ],
        linkToFeature: 'family-kit',
        linkLabel: 'postEncounterData.poaActivationFtLinkLabel',
      },
      {
        id: 'notify-network-ft',
        title: 'postEncounterData.notifyNetworkFtTitle',
        icon: 'UsersThree',
        urgency: 'medium',
        content: 'postEncounterData.notifyNetworkFtContent',
        checklist: [
          'postEncounterData.notifyNetworkFtCheck1',
          'postEncounterData.notifyNetworkFtCheck2',
          'postEncounterData.notifyNetworkFtCheck3',
          'postEncounterData.notifyNetworkFtCheck4',
          'postEncounterData.notifyNetworkFtCheck5',
          'postEncounterData.notifyNetworkFtCheck6',
        ],
        linkToFeature: 'trusted-contacts',
        linkLabel: 'postEncounterData.notifyNetworkFtLinkLabel',
      },
      {
        id: 'document-ft',
        title: 'postEncounterData.documentFtTitle',
        icon: 'NotePencil',
        urgency: 'medium',
        content: 'postEncounterData.documentFtContent',
        checklist: [
          'postEncounterData.documentFtCheck1',
          'postEncounterData.documentFtCheck2',
          'postEncounterData.documentFtCheck3',
          'postEncounterData.documentFtCheck4',
          'postEncounterData.documentFtCheck5',
          'postEncounterData.documentFtCheck6',
        ],
        linkToFeature: 'encounter-log-after',
        linkLabel: 'postEncounterData.documentFtLinkLabel',
      },
    ],
  },

  // ── Branch 3: Agents Left Without Entry ───────────────
  {
    id: 'agents-left',
    title: 'postEncounterData.agentsLeftTitle',
    description: 'postEncounterData.agentsLeftDesc',
    icon: 'ShieldCheck',
    color: 'emerald',
    sections: [
      {
        id: 'document-visit-al',
        title: 'postEncounterData.documentVisitAlTitle',
        icon: 'NotePencil',
        urgency: 'medium',
        content: 'postEncounterData.documentVisitAlContent',
        checklist: [
          'postEncounterData.documentVisitAlCheck1',
          'postEncounterData.documentVisitAlCheck2',
          'postEncounterData.documentVisitAlCheck3',
          'postEncounterData.documentVisitAlCheck4',
          'postEncounterData.documentVisitAlCheck5',
          'postEncounterData.documentVisitAlCheck6',
          'postEncounterData.documentVisitAlCheck7',
        ],
        linkToFeature: 'encounter-log-after',
        linkLabel: 'postEncounterData.documentVisitAlLinkLabel',
      },
      {
        id: 'followup-patterns-al',
        title: 'postEncounterData.followupPatternsAlTitle',
        icon: 'Eye',
        urgency: 'medium',
        content: 'postEncounterData.followupPatternsAlContent',
        checklist: [
          'postEncounterData.followupPatternsAlCheck1',
          'postEncounterData.followupPatternsAlCheck2',
          'postEncounterData.followupPatternsAlCheck3',
          'postEncounterData.followupPatternsAlCheck4',
          'postEncounterData.followupPatternsAlCheck5',
          'postEncounterData.followupPatternsAlCheck6',
          'postEncounterData.followupPatternsAlCheck7',
        ],
      },
      {
        id: 'fortify-prep-al',
        title: 'postEncounterData.fortifyPrepAlTitle',
        icon: 'Shield',
        urgency: 'info',
        content: 'postEncounterData.fortifyPrepAlContent',
        checklist: [
          'postEncounterData.fortifyPrepAlCheck1',
          'postEncounterData.fortifyPrepAlCheck2',
          'postEncounterData.fortifyPrepAlCheck3',
          'postEncounterData.fortifyPrepAlCheck4',
          'postEncounterData.fortifyPrepAlCheck5',
          'postEncounterData.fortifyPrepAlCheck6',
          'postEncounterData.fortifyPrepAlCheck7',
        ],
        linkToFeature: 'family-kit',
        linkLabel: 'postEncounterData.fortifyPrepAlLinkLabel',
      },
      {
        id: 'consult-attorney-al',
        title: 'postEncounterData.consultAttorneyAlTitle',
        icon: 'Scales',
        urgency: 'info',
        content: 'postEncounterData.consultAttorneyAlContent',
        checklist: [
          'postEncounterData.consultAttorneyAlCheck1',
          'postEncounterData.consultAttorneyAlCheck2',
          'postEncounterData.consultAttorneyAlCheck3',
          'postEncounterData.consultAttorneyAlCheck4',
          'postEncounterData.consultAttorneyAlCheck5',
          'postEncounterData.consultAttorneyAlCheck6',
        ],
        hotlines: [
          { name: 'National Immigrant Justice Center', number: '312-660-1370' },
          { name: 'NILC', number: '213-639-3900' },
        ],
      },
    ],
  },
];

// ── Shared sections appended to all branches ────────────
export const SHARED_SECTIONS = [
  {
    id: 'court-rights',
    title: 'postEncounterData.courtRightsTitle',
    icon: 'Gavel',
    urgency: 'info',
    content: 'postEncounterData.courtRightsContent',
    infoPoints: [
      'postEncounterData.courtRightsInfo1',
      'postEncounterData.courtRightsInfo2',
      'postEncounterData.courtRightsInfo3',
      'postEncounterData.courtRightsInfo4',
      'postEncounterData.courtRightsInfo5',
      'postEncounterData.courtRightsInfo6',
      'postEncounterData.courtRightsInfo7',
      'postEncounterData.courtRightsInfo8',
    ],
  },
  {
    id: 'resources',
    title: 'postEncounterData.resourcesTitle',
    icon: 'Phone',
    urgency: 'info',
    content: 'postEncounterData.resourcesContent',
    hotlines: [
      { name: 'National Immigration Detention Hotline', number: '1-833-560-0927' },
      { name: 'ACLU Immigrants\' Rights Project', number: '212-549-2660' },
      { name: 'National Immigrant Justice Center', number: '312-660-1370' },
      { name: 'NILC (National Immigration Law Center)', number: '213-639-3900' },
      { name: 'United We Dream', number: '1-844-363-1423' },
    ],
    links: [
      { name: 'ICE Online Detainee Locator', url: 'https://locator.ice.gov' },
      { name: 'DHS OIG Hotline (File Complaint)', url: 'https://www.oig.dhs.gov/hotline' },
      { name: 'DHS CRCL Complaint Form', url: 'https://www.dhs.gov/file-crcl-complaint' },
      { name: 'ACLU Know Your Rights', url: 'https://www.aclu.org/know-your-rights/immigrants-rights' },
      { name: 'NILC Resources', url: 'https://www.nilc.org' },
      { name: 'Immigration Advocates Network', url: 'https://www.immigrationadvocates.org/legaldirectory/' },
    ],
  },
];
